import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from './views/auth/LoginPage.vue'
import AuthHandle from './views/auth/AuthHandle.vue'
import HomePage from './views/app/HomePage.vue'
import GerenciarFisioterapeutas from './views/app/GerenciarFisioterapeutas.vue'
import GerenciarPacientes from './views/app/GerenciarPacientes.vue'
import GerenciarAtendimentos from './views/app/GerenciarAtendimentos.vue'
// import RelatoriosAnalise from './views/app/RelatoriosAnalise.vue'
import ConfiguracoesSistemas from './views/app/ConfiguracoesSistema.vue'
import GerenciarNotificacoes from './views/app/GerenciarNotificacoes.vue'
import GerenciarAvaliacoes from './views/app/GerenciarAvaliacoes.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '',
      name: 'login',
      component: Login
    },
    {
      path: '/auth',
      component: AuthHandle,
      props: (route) => ({
        mode: route.query.mode,
        oobCode: route.query.oobCode,
        apiKey: route.query.apiKey,
        lang: route.query.lang
      })
    },
    {
      path: '/',
      component: HomePage,
      meta: { requiresAuth: true },
      children: [
        // {
        //   path: '/relatorios',
        //   component: RelatoriosAnalise
        // },
        {
          path: '/pacientes',
          component: GerenciarPacientes,
          meta: { requiresAuth: true }
        },
        {
          path: '/fisioterapeutas',
          component: GerenciarFisioterapeutas,
          meta: { requiresAuth: true }
        },
        {
          path: '/consultas',
          component: GerenciarAtendimentos,
          meta: { requiresAuth: true }
        },
        {
          path: '/configuracoes',
          component: ConfiguracoesSistemas,
          meta: { requiresAuth: true }
        },
        {
          path: '/notificacoes',
          component: GerenciarNotificacoes,
          meta: { requiresAuth: true }
        },
        {
          path: '/avaliacoes',
          component: GerenciarAvaliacoes,
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.authenticated) {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
